export default "__VITE_ASSET__ZHbqM2z9__"